import React from 'react';
import { Box, Alert, CircularProgress } from '@mui/material';

export default function CanvasEditor({
  canvasRef,
  backgroundImage,
  isCameraActive,
  isDragging,
  loadedSilhouette,
  isProcessing,
  validationError,
  onValidationErrorClose,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
}) {
  return (
    <>
      <canvas
        ref={canvasRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={backgroundImage && !isCameraActive ? {
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          display: 'block',
          touchAction: 'none',
          cursor: isDragging ? 'grabbing' : (loadedSilhouette ? 'grab' : 'default'),
        } : {
          cursor: isDragging ? 'grabbing' : (loadedSilhouette && loadedSilhouette.naturalWidth > 0 ? 'grab' : (!backgroundImage && !isCameraActive ? 'pointer' : 'default')),
          maxWidth: '100%',
          maxHeight: '70vh',
          display: 'block',
          touchAction: 'none'
        }}
      />

      {validationError && (
        <Alert severity="error" onClose={onValidationErrorClose} sx={{ mb: 1 }}>
          {validationError}
        </Alert>
      )}

      {isProcessing && (
        <Box sx={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          backgroundColor: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(16px)', zIndex: 30,
          borderRadius: 1,
        }}>
          <CircularProgress sx={{ color: 'white' }} />
        </Box>
      )}
    </>
  );
}
